import Quote from '@/models/Quote'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    quoteDetails: null,
  },

  mutations: {
    setQuoteList(state, quotes) {
      each(quotes, (quote) => {
        const exist = find(state.list, { id: quote.id })
        if (!exist) {
          state.list.push(new Quote(quote))
        }
      })
    },

    clearQuoteList(state) {
      state.list = []
    },

    setQuoteListMeta(state, meta) {
      state.listMeta = meta
    },

    setQuoteDetails(state, quote) {
      if (quote instanceof Quote) {
        state.quoteDetails = quote
      } else {
        state.quoteDetails = new Quote(quote)
      }
    },

    clearQuoteDetails(state) {
      state.quoteDetails = null
    },
  },

  actions: {
    async getQuotes({ commit }, params) {
      const query = Quote.page(params.page || 1).orderBy(params.sort)
      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setQuoteList', res.data)
      commit('setQuoteListMeta', res.meta)
    },

    async getQuoteDetails({ commit }, id) {
      const { data } = await Api.get(`admin/quotes/${id}`)
      commit('setQuoteDetails', data.data)
    },

    async createQuote({ commit }, formData) {
      const { data } = await Api.post(`admin/quotes`, formData)
      commit('setQuoteDetails', data.data)
    },

    async updateQuote({ commit }, formData) {
      const { data } = await Api.put(`admin/quotes/${formData.id}`, formData)
      commit('setQuoteDetails', data.data)
    },

    async deleteQuote({ commit }, id) {
      await Api.delete(`admin/quotes/${id}`)
      commit('clearQuoteDetails', id)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = params.search
        ? `admin/quotes/export/${params.search}`
        : `admin/quotes/export`
      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },
}
